module.exports = __webpack_public_path__ + "img/about.e60f1da5.jpg";